/* eslint-disable @typescript-eslint/no-explicit-any */
import {QueryClient} from '@tanstack/react-query';

// Create a client with optimized defaults for Next.js
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 15 minutes by default
      staleTime: 15 * 60 * 1000,
      // Keep unused data in cache for 30 minutes
      gcTime: 30 * 60 * 1000,
      // Retry failed requests 3 times
      retry: (failureCount, error: any) => {
        // Don't retry on authentication errors
        if (error?.message?.includes('Authentication failed')) {
          return false;
        }
        // Don't retry on 403 (Forbidden) or 404 (Not Found) errors
        // These are client errors that won't be resolved by retrying
        if (error?.status === 403 || error?.status === 404) {
          return false;
        }
        return failureCount < 3;
      },
      // Don't refetch on window focus (good for mobile)
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
      // Don't refetch on mount if data is fresh
      refetchOnMount: false,
      // Don't refetch on interval by default
      refetchInterval: false,
      refetchIntervalInBackground: false,
      // Enable structural sharing - prevents unnecessary re-renders when data shape is the same
      structuralSharing: true,
      // Network mode - only run queries when online
      networkMode: 'online'
      // Enable query deduplication (prevents duplicate simultaneous requests)
      // This is enabled by default but explicitly set for clarity
    },
    mutations: {
      // Retry mutations once, but not for 403 or 404 errors
      retry: (failureCount, error: any) => {
        // Don't retry on 403 (Forbidden) or 404 (Not Found) errors
        // These are client errors that won't be resolved by retrying
        if (error?.status === 403 || error?.status === 404) {
          return false;
        }
        return failureCount < 1;
      },
      // Network mode for mutations
      networkMode: 'online'
    }
  }
});
